export function isString(v: unknown): v is string {
  return typeof v === 'string'
}

export function isNumber(v: unknown): v is number {
  return typeof v === 'number'
}

export function isObject(v: unknown): v is object {
  return typeof v === 'object'
}

export function isBoolean(v: unknown): v is boolean {
  return typeof v === 'boolean'
}
